<ng-container *ngIf="chipUser$ | async as chipUser">
  <!--
    FE-196 — the chip OPENS THE ACCOUNT MENU; it is not a plain link. Unit D
    replaced the header's `<app-login-logout>` with this chip for signed-in
    users, and that component's authenticated branch (My profile + Logout) was
    the only Log out in the whole shell: the `/user/**` sidebar has none, and
    the burger drawer's copy is `display: none` above 579px. So a signed-in
    resident had no way to log out on desktop at all.

    Which presentation opens depends on the width. At or below 640px
    `[matMenuTriggerFor]` is deliberately NULL and `onChipClick()` raises the
    full-screen sheet instead; above it, the dropdown. MatMenuTrigger's own
    click handler still runs in both cases, but `_openMenu` returns early
    without a panel, so only one of the two ever acts.
  -->
  <button type="button"
          class="account-chip"
          data-testid="account_chip"
          [matMenuTriggerFor]="(isPhone$ | async) ? null : accountMenu"
          (click)="onChipClick()"
          [attr.aria-haspopup]="(isPhone$ | async) ? 'dialog' : 'menu'"
          [attr.aria-expanded]="(isPhone$ | async) ? sheetOpen : null"
          [attr.aria-label]="('menu.account' | translate) + ' — ' + chipUser.label">
    <span class="account-chip__name">{{ chipUser.label }}</span>
    <span class="account-chip__avatar" aria-hidden="true">{{ chipUser.initials }}</span>
  </button>

  <!-- ── Desktop: dropdown anchored to the chip ── -->
  <mat-menu #accountMenu="matMenu" class="account-menu" xPosition="before">
    <a mat-menu-item
       *ngFor="let link of accountLinks"
       [routerLink]="link.url">{{ link.labelKey | translate }}</a>
    <button type="button"
            mat-menu-item
            class="account-menu__logout"
            data-testid="account_menu_logout"
            (click)="logout($event)">
      {{ 'menu.logout' | translate }}
    </button>
  </mat-menu>

  <!--
    ── Phone: full-screen sheet ──
    Only the account items — this is deliberately NOT the burger drawer, which
    carries the whole site nav. Kept in the DOM rather than *ngIf'd so the panel
    can slide rather than appear; `.account-sheet` is `display: none` above the
    breakpoint, so it costs desktop nothing.
  -->
  <div class="account-sheet"
       [class.account-sheet--open]="sheetOpen">
    <div class="account-sheet__panel"
         role="dialog"
         aria-modal="true"
         [attr.aria-label]="('menu.account' | translate) + ' — ' + chipUser.label">

      <div class="account-sheet__head">
        <span class="account-sheet__avatar" aria-hidden="true">{{ chipUser.initials }}</span>
        <span class="account-sheet__name">{{ chipUser.label }}</span>
        <button type="button"
                class="account-sheet__close"
                data-testid="account_sheet_close"
                [attr.aria-label]="'menu.close' | translate"
                (click)="closeSheet()">
          <img src="./assets/images/icon-menu-close.svg" alt="">
        </button>
      </div>

      <nav class="account-sheet__list">
        <a *ngFor="let link of accountLinks"
           [routerLink]="link.url"
           (click)="closeSheet()">{{ link.labelKey | translate }}</a>
        <button type="button"
                class="account-sheet__logout"
                data-testid="account_sheet_logout"
                (click)="logout($event)">
          {{ 'menu.logout' | translate }}
        </button>
      </nav>
    </div>
  </div>
</ng-container>
